import { Injectable, OnDestroy } from '@angular/core';
import { BroadcastMessage } from '@firebird-web/shared-interfaces';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class BroadcastChannelService implements OnDestroy {
  private channel = new BroadcastChannel('app_channel');
  private messageSource = new Subject<BroadcastMessage>();
  messages$ = this.messageSource.asObservable();

  constructor() {
    // Listen for incoming messages
    this.channel.onmessage = (event) => {
      this.messageSource.next(event.data);
    };
  }

  sendMessage(message: BroadcastMessage) {
    this.channel.postMessage(message);
  }

  ngOnDestroy() {
    this.channel.close();
    this.messageSource.complete();
  }
}
